import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import Seo from '../../../components/seo';
import './exchange.css';
import { MypageContext, useMypageStore } from "../context";
import { useLocation, withRouter } from "react-router-dom";
import Pagination from "../../../components/pagination";
import { UsersService } from 'services/index';
import Cookie from 'utils/cookie';

const MedalExchangeHistory = observer(({ history }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const { mypageStore } = useMypageStore(MypageContext);
  const [refresh, setRefresh] = useState(false);

  const page = parseInt(query.get('page')) || 1;

  const [showPopup, setShowPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelReason, setCancelReason] = useState('');
  const mbIdByuserLogin = Cookie.getCookie('mb_id');

  const statusText = {
    cancel:'취소',
    ready: '신청중',
    progress: '처리중',
    reject: '거절',
    complete: '완료'
  };

  useEffect(() => {
    mypageStore.actionMedalExchangeHistoryList({ page });
  }, [page,refresh]);

  const numberFormat = (number) => {
    if (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return 0;
  };

  const handleClicOpenModal = (item) => {
    if (item.status === 'ready' || item.status === 'progress') {
      setSelectedItem(item);
      setCancelReason('');
      setShowPopup(true);
    }
  };

  const submitFormReject = async (exchangeId,rejectReason) => {

    const isConfirmed = window.confirm('건빵환전 신청을 취소하시겠습니까?');

    if (!isConfirmed) return;

    const res = await mypageStore.actionMedalRejectExchange(exchangeId, rejectReason);

    if (res.code === 200) {
      alert(res.data.message);
      setShowPopup(false);
      setRefresh((prev) => !prev);
    }else if(res.code === 400){
      alert(res.message);
    }

  }

  return (
    <>
      <Seo title={'마이페이지 캐쉬'} />
      <div className='exchange-form'>
        <h1 className='title'>건빵 환전 내역</h1>
        <button className='btn_back' onClick={() => history.push('/mypage/medal')}>
          닫기
        </button>

        <table className={'medal_history_table'}>
          <thead>
            <tr>
              <th>신청 일시</th>
              <th>신청 수량 (개)</th>
              <th>수령액</th>
              <th>상태</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {mypageStore.data.medal_history_list.list &&
            mypageStore.data.medal_history_list.count &&
            mypageStore.data.medal_history_list.count > 0 ? (
              mypageStore.data.medal_history_list.list.map((item, index) => (
              <tr
                  key={index}
                  className={item.status === 'ready' ? 'clickable-row' : ''}
                >
                  <td>{item.create_datetime}</td>
                  <td>{numberFormat(item.amount)}</td>
                  <td>{numberFormat(item.receipt_price)}</td>
                  <td className={'flex-column'}>
                    <span className={`exchange-status ${item.status}`}>{(item.status === 'cancel') ? '취소' : statusText[item.status]}</span>
                  </td>
                  <td className={'flex-column'}>
                    {item.status === 'ready' || item.status === 'progress' ? <button onClick={() => handleClicOpenModal(item)} className='btn-cancel'>취소</button> : '' }
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className={'empty-row'}>
                  내역이 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {mypageStore.data.medal_history_list.count ? (
          <Pagination page={page} totalCount={mypageStore.data.medal_history_list.count} tab={''} rowCount={10} />
        ) : null}

        <div className='readme-wrapper'>
          <div className='readme'>
            <p>환전 신청 전에 꼭 읽어주세요!</p>
            <ul>
              <li className='ico_indent'>
                환전 신청한 금액은 신청일로부터 영업일 5일 이내 입금 처리됩니다. (휴일인 경우 익일 영업일에 일괄 처리)
              </li>
              <li className='ico_indent'>건빵이 100개 이상일 때부터 현금 환전이 가능합니다. (건빵1개 100원)</li>
              <li className='ico_indent'>
                불법적인 용도나, 법적인 문제가 발생할 경우, 비정상적인 경우, 네임드 약관에 위배가되는 경우 환전 승인이
                거절될수 있습니다.
              </li>
              <li className='ico_indent'>
                최근 90일간 환전 처리결과 내역을 확인하실 수 있으며, 90일 이후 내역은 모두 소멸됩니다.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {showPopup && selectedItem && (
        <div className='popup-overlay'>
          <div className='popup'>
            <div className='form-group form-with-unit'>
              <div className='input-label'>
                <div className='title-label'>
                  <label>환전 신청 건빵</label>
                </div>
                <label className='error-label hide'></label>
              </div>
              <div className='input-with-unit'>
                <input className='box-input' type='text' required='' value={numberFormat(selectedItem.amount)} data-gtm-form-interact-field-id='0' />
                <span className='input-unit'>개</span>
              </div>
              <p className='input-note gray-text'>(건빵 100개 이상 부터 현금 환전이 가능)</p>
            </div>
            <div className="form-group form-with-unit"><label>환전 신청 금액</label>
              <div className="input-with-unit"><input className="box-input" type="string" disabled="" value={numberFormat(selectedItem.price)} />
                <span className="input-unit">원</span></div>
            </div>

            <div className="form-group form-with-unit"><label>수수료</label>
              <div className="input-with-unit"><input className="box-input" type="string" disabled=""
                                                      value={numberFormat(selectedItem.fee)} />
                <span className="input-unit">원</span></div>
              <p className="input-note gray-text">수수료 10% 금액</p></div>

            <div className="form-group form-with-unit"><label>취소사유</label>
              <div className="input-with-unit">
                <textarea className="box-input" type="string" rows="3"  value={cancelReason}
                          onChange={(e) => setCancelReason(e.target.value)}></textarea>
                <span className="input-unit"></span>
              </div>

            </div>

            <div id="receipts-result"><strong className="sum">실수령 금액</strong>
              <em className="cnt" id="actual_receipts">{numberFormat(selectedItem.receipt_price)}</em>
              <span className="cnt_unit">원</span>
            </div>

            <div className="button-group">
              <button type="button" className="submit-button " onClick={() => {
                submitFormReject(selectedItem.id,cancelReason)
              }}>취소하기</button>
              <button type="button" className="cancel-button " onClick={() => {
                setShowPopup(false);
              }}>창닫기</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default withRouter(MedalExchangeHistory);